import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import axios from "axios";
import "./RegisterPage.css";
import unnamed from "../assets/images/3971033.jpg";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import { GrFormPreviousLink } from "react-icons/gr";
import { FaUserAlt } from "react-icons/fa";
import { FaUserTie } from "react-icons/fa";
import { FaBook } from "react-icons/fa";


const RegisterPage = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formDatas, setFormData] = useState({});
  const [step, setStep] = useState(1);

  useEffect(() => {}, []);

  const handleNextStep = async (e) => {
    e.preventDefault();

    const form = document.querySelector("form");
    const formData = new FormData(form);
    const data = Object.fromEntries(formData.entries());

    if (step === 1) {
      const requiredFields = [];

      setStep(2);
    } else if (step === 2) {
      setStep(3);
    }
    if (step === 3) {
      // toast.error("يرجى الموافقة على الشروط والأحكام قبل الإرسال");
      // return;
    }
  };

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result.split(",")[1]);
      reader.onerror = (error) => reject(error);
    });

  const fileToBase64Object = async (file) => {
    const base64Data = await toBase64(file);
    return {
      filename: file.name,
      data: base64Data,
    };
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
     toast.error(" تم التسجيل بنجاح");
    return;
    // setStep(1);
  };

  return (
    <>
      <div className="container" dir="rtl">
        <div
          style={{
            width: "100%",
            boxShadow: "2px 2px 2px #777",
            borderRadius: "20px",
            marginBottom: "20px",
          }}
        >
          <img
            src={unnamed}
            alt="شريط"
            style={{
              borderRadius: "20px",
              width: "100%",
              height: "300px",
              objectFit: "cover",
            }}
          />
        </div>
{/* 
        <hr /> */}

           

            <div className="card" style={{background:"#fff", borderRadius: "20px", boxShadow: "2px 2px 2px #eee"}}>
              <div className="card-header">
              <div className="row" style={{ marginTop: "80px" }}>
  <div className="col-12 col-lg-6">
    <h4 style={{ paddingTop: "20px" }}>نموذج تسجيل الطالب</h4>
  </div>

  <div className="col-12 col-lg-6">
    <div className="steps-progress d-flex justify-content-center align-items-center mb-5">

      {[
        { label: "البيانات الشخصية", icon: <FaUserAlt /> },
        { label: "بيانات ولي الأمر", icon: <FaUserTie /> },
        { label: "البيانات الدراسية", icon: <FaBook /> },
      ].map((stepData, index, arr) => {
        const currentStep = index + 1;
        const isCompleted = step > currentStep;
        const isActive = step === currentStep;

        let statusClass = "";
        if (isCompleted) statusClass = "completed";
        else if (isActive) statusClass = "active";
        else statusClass = "upcoming";

        return (
          <div key={index} className="step-wrapper d-flex align-items-center">
            <div className="step-item d-flex flex-column align-items-center text-center position-relative">
              <div className={`bubble ${statusClass}`} style={{ fontSize: "18px" }}>
                {stepData.icon}
              </div>
              <small className={`label ${statusClass}`} style={{ marginTop: "8px" }}>
                {stepData.label}
              </small>
            </div>

            {index !== arr.length - 1 && (
              <div
                className={`connector ${
                  step > currentStep ? "completed" : "upcoming"
                }`}
              />
            )}
          </div>
        );
      })}
    </div>
  </div>
</div>
              </div>
                  <div className="card-body">

                  <form onSubmit={handleSubmit} encType="multipart/form-data">
              <div className="row">
                {step === 1 && (
                  <>

          
        
                    <div className="col-12 mb-3 mt-4" dir="rtl">
                      <label
                        htmlFor="first_name"
                        style={{
                          fontFamily: "Cairo",
                          fontSize: "14px",
                          color: "black",
                          marginBottom: "5px",
                          display: "block",
                          textAlign: "right",
                        }}
                      >
                        الاسم الأول
                      </label>

                      <TextField
                        id="first_name"
                        variant="filled"
                        name="first_name"
                        fullWidth
                        value={formDatas.first_name || ""}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            first_name: e.target.value,
                          }))
                        }
                        InputProps={{
                          sx: {
                            backgroundColor: "#fff",
                            color: "black",
                            direction: "rtl",
                            textAlign: "right",
                            borderRadius: "8px",
                            fontFamily: "Cairo",
                            paddingRight: "16px",
                          },
                        }}
                      />
                    </div>

                    <div className="col-12 col-lg-6 mb-3 mt-4" dir="rtl">
                      <label
                        htmlFor="middle_name"
                        style={{
                          fontFamily: "Cairo",
                          fontSize: "14px",
                          color: "black",
                          marginBottom: "5px",
                          display: "block",
                          textAlign: "right",
                        }}
                      >
                        الاسم الأوسط
                      </label>

                      <TextField
                        id="middle_name"
                        variant="filled"
                        name="middle_name"
                        fullWidth
                        value={formDatas.middle_name || ""}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            middle_name: e.target.value,
                          }))
                        }
                        InputProps={{
                          sx: {
                            backgroundColor: "#fff",
                            color: "black",
                            direction: "rtl",
                            textAlign: "right",
                            borderRadius: "8px",
                            fontFamily: "Cairo",
                            paddingRight: "16px",
                          },
                        }}
                      />
                    </div>

                    <div className="col-12 col-lg-6 mb-3 mt-4" dir="rtl">
                      <label
                        htmlFor="last_name"
                        style={{
                          fontFamily: "Cairo",
                          fontSize: "14px",
                          color: "black",
                          marginBottom: "5px",
                          display: "block",
                          textAlign: "right",
                        }}
                      >
                        الاسم الأخير
                      </label>

                      <TextField
                        id="last_name"
                        variant="filled"
                        name="last_name"
                        fullWidth
                        value={formDatas.last_name || ""}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            last_name: e.target.value,
                          }))
                        }
                        InputProps={{
                          sx: {
                            backgroundColor: "#fff",
                            color: "black",
                            direction: "rtl",
                            textAlign: "right",
                            borderRadius: "8px",
                            fontFamily: "Cairo",
                            paddingRight: "16px",
                          },
                        }}
                      />
                    </div>

                    <div className="col-12 col-lg-6 mb-3 mt-4" dir="rtl">
                      <label
                        htmlFor="phone"
                        style={{
                          fontFamily: "Cairo",
                          fontSize: "14px",
                          color: "black",
                          marginBottom: "5px",
                          display: "block",
                          textAlign: "right",
                        }}
                      >
                        رقم الهاتف
                      </label>

                      <TextField
                        id="phone"
                        variant="filled"
                        name="phone"
                        type="number"
                        fullWidth
                        value={formDatas.phone || ""}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            phone: e.target.value,
                          }))
                        }
                        InputProps={{
                          sx: {
                            backgroundColor: "#fff",
                            color: "black",
                            direction: "rtl",
                            textAlign: "right",
                            borderRadius: "8px",
                            fontFamily: "Cairo",
                            paddingRight: "16px",
                          },
                        }}
                      />
                    </div>

                    <div className="col-12 col-lg-6 mb-3 mt-4" dir="rtl">
                      <label
                        htmlFor="address"
                        style={{
                          fontFamily: "Cairo",
                          fontSize: "14px",
                          color: "black",
                          marginBottom: "5px",
                          display: "block",
                          textAlign: "right",
                        }}
                      >
                        العنوان
                      </label>

                      <TextField
                        id="address"
                        variant="filled"
                        type="text"
                        name="address"
                        fullWidth
                        value={formDatas.address || ""}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            address: e.target.value,
                          }))
                        }
                        InputProps={{
                          sx: {
                            backgroundColor: "#fff",
                            color: "black",
                            direction: "rtl",
                            textAlign: "right",
                            borderRadius: "8px",
                            fontFamily: "Cairo",
                            paddingRight: "16px",
                          },
                        }}
                      />
                    </div>

                    <div className="col-12 col-lg-6 mb-3">
                      <label
                        className="form-label d-block"
                        style={{ fontWeight: "bold" }}
                      >
                        النوع
                      </label>
                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="gender"
                          value="m"
                          checked={formDatas.gender === "m"}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              gender: e.target.value,
                            }))
                          }
                        />
                        <label className="form-check-label">ذكر</label>
                      </div>
                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="gender"
                          value="f"
                          checked={formDatas.gender === "f"}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              gender: e.target.value,
                            }))
                          }
                        />
                        <label className="form-check-label">أنثى</label>
                      </div>
                    </div>
                    <div className="col-12 col-lg-6 mb-3 ">
            <label
              className="form-label d-block pb-1"
              style={{ fontWeight: "bold" }}
            >
              حدد نوع الدراسه
            </label>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="register_type"
                value="presence"
                checked={formDatas.register_type === "presence"}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    register_type: e.target.value,
                  }))
                }
              />
              <label className="form-check-label">حضوري</label>
            </div>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="register_type"
                value="platform"
                checked={formDatas.register_type === "platform"}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    register_type: e.target.value,
                  }))
                }
              />
              <label className="form-check-label">اونلاين</label>
            </div>
          </div>

                    <div className="col-12 mb-3 mt-4" dir="rtl">
                      <label
                        htmlFor="birth_date"
                        style={{
                          fontFamily: "Cairo",
                          fontSize: "14px",
                          color: "black",
                          marginBottom: "5px",
                          display: "block",
                          textAlign: "right",
                        }}
                      >
                        تاريخ الميلاد
                      </label>

                      <TextField
                        id="birth_date"
                        type="date"
                        variant="filled"
                        name="birth_date"
                        fullWidth
                        required
                        value={formDatas.birth_date || ""}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            birth_date: e.target.value,
                          }))
                        }
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                          sx: {
                            backgroundColor: "#fff",
                            color: "black",
                            direction: "rtl",
                            textAlign: "right",
                            borderRadius: "8px",
                            fontFamily: "Cairo",
                            paddingRight: "16px",
                          },
                        }}
                      />
                    </div>

                  

                    <div className="col-12 text-start mt-4">
                      <button
                        type="button"
                        className="btn btn px-5"
                        style={{ background: "#95c02b", color: "#fff" }}
                        onClick={handleNextStep}
                      >
                        التالي
                        <span className="me-2">
                          <GrFormPreviousLink />
                        </span>
                      </button>
                    </div>
                  </>
                )}
                {step === 2 && (
                  <>
                    <div className="col-12 mb-3 mt-4" dir="rtl">
                      <label
                        htmlFor="guardian_name"
                        style={{
                          fontFamily: "Cairo",
                          fontSize: "14px",
                          color: "black",
                          marginBottom: "5px",
                          display: "block",
                          textAlign: "right",
                        }}
                      >
                        اسم ولي الامر
                      </label>

                      <TextField
                        id="guardian_name"
                        variant="filled"
                        type="text"
                        name="guardian_name"
                        fullWidth
                        value={formDatas.guardian_name || ""}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            guardian_name: e.target.value,
                          }))
                        }
                        InputProps={{
                          sx: {
                            backgroundColor: "#fff",
                            color: "black",
                            direction: "rtl",
                            textAlign: "right",
                            borderRadius: "8px",
                            fontFamily: "Cairo",
                            paddingRight: "16px",
                          },
                        }}
                      />
                    </div>

                    <div className="col-12 col-lg-6 mb-3 mt-4" dir="rtl">
                      <label
                        htmlFor="kinship"
                        style={{
                          fontFamily: "Cairo",
                          fontSize: "14px",
                          color: "black",
                          marginBottom: "5px",
                          display: "block",
                          textAlign: "right",
                        }}
                      >
                        صلة القرابة
                      </label>

                      <TextField
                        id="kinship"
                        variant="filled"
                        type="text"
                        name="kinship"
                        fullWidth
                        value={formDatas.kinship || ""}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            kinship: e.target.value,
                          }))
                        }
                        InputProps={{
                          sx: {
                            backgroundColor: "#fff",
                            color: "black",
                            direction: "rtl",
                            textAlign: "right",
                            borderRadius: "8px",
                            fontFamily: "Cairo",
                            paddingRight: "16px",
                          },
                        }}
                      />
                    </div>

                    <div className="col-12 col-lg-6 mb-3 mt-4" dir="rtl">
                      <label
                        htmlFor="email"
                        style={{
                          fontFamily: "Cairo",
                          fontSize: "14px",
                          color: "black",
                          marginBottom: "5px",
                          display: "block",
                          textAlign: "right",
                        }}
                      >
                        البريد الإلكتروني
                      </label>

                      <TextField
                        id="email"
                        variant="filled"
                        type="email"
                        name="email"
                        fullWidth
                        value={formDatas.email || ""}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            email: e.target.value,
                          }))
                        }
                        InputProps={{
                          sx: {
                            backgroundColor: "#fff",
                            color: "black",
                            direction: "rtl",
                            textAlign: "right",
                            borderRadius: "8px",
                            fontFamily: "Cairo",
                            paddingRight: "16px",
                          },
                        }}
                      />
                    </div>

                    <div className="col-12 col-lg-6 mb-3 mt-4" dir="rtl">
                      <label
                        htmlFor="guardian_phone"
                        style={{
                          fontFamily: "Cairo",
                          fontSize: "14px",
                          color: "black",
                          marginBottom: "5px",
                          display: "block",
                          textAlign: "right",
                        }}
                      >
                        رقم الهاتف
                      </label>

                      <TextField
                        id="guardian_phone"
                        variant="filled"
                        name="guardian_phone"
                        type="number"
                        fullWidth
                        value={formDatas.guardian_phone || ""}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            guardian_phone: e.target.value,
                          }))
                        }
                        InputProps={{
                          sx: {
                            backgroundColor: "#fff",
                            color: "black",
                            direction: "rtl",
                            textAlign: "right",
                            borderRadius: "8px",
                            fontFamily: "Cairo",
                            paddingRight: "16px",
                          },
                        }}
                      />
                    </div>

                    <div className="col-12 col-lg-6 mb-3 mt-4" dir="rtl">
                      <label
                        htmlFor="guardian_address"
                        style={{
                          fontFamily: "Cairo",
                          fontSize: "14px",
                          color: "black",
                          marginBottom: "5px",
                          display: "block",
                          textAlign: "right",
                        }}
                      >
                        العنوان
                      </label>

                      <TextField
                        id="guardian_address"
                        variant="filled"
                        type="text"
                        name="guardian_address"
                        fullWidth
                        value={formDatas.guardian_address || ""}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            guardian_address: e.target.value,
                          }))
                        }
                        InputProps={{
                          sx: {
                            backgroundColor: "#fff",
                            color: "black",
                            direction: "rtl",
                            textAlign: "right",
                            borderRadius: "8px",
                            fontFamily: "Cairo",
                            paddingRight: "16px",
                          },
                        }}
                      />
                    </div>

                    <div className="col-12 mt-4">
                      <div className="d-flex justify-content-between">
                        <button
                          type="button"
                          className="btn btn-secondary px-5"
                          onClick={() => setStep(1)}
                        >
                          الرجوع
                        </button>

                        <button
                          type="button"
                          className="btn btn px-5"
                          style={{ background: "#95c02b", color: "#fff" }}
                          onClick={handleNextStep}
                        >
                          التالي
                          <span className="me-2">
                            <GrFormPreviousLink />
                          </span>
                        </button>
                      </div>
                    </div>
                  </>
                )}
                {step === 3 && (
                  <>
                    <div className="col-12 mb-3 mt-4" dir="rtl">
                      <label
                        htmlFor="school"
                        style={{
                          fontFamily: "Cairo",
                          fontSize: "14px",
                          color: "black",
                          marginBottom: "5px",
                          display: "block",
                          textAlign: "right",
                        }}
                      >
                        المدرسة
                      </label>

                      <TextField
                        id="school"
                        name="school"
                        select
                        fullWidth
                        required
                        variant="filled"
                        value={formDatas.school || ""}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            school: e.target.value,
                          }))
                        }
                        InputProps={{
                          sx: {
                            backgroundColor: "#fff",
                            color: "black",
                            direction: "rtl",
                            textAlign: "right",
                            borderRadius: "8px",
                            fontFamily: "Cairo",
                            paddingRight: "16px",
                          },
                        }}
                      >
                        <MenuItem value="">اختر اسم المدرسة</MenuItem>
                        <MenuItem value="مدرسة النور">مدرسة النور</MenuItem>
                        <MenuItem value="مدرسة الأمل">مدرسة الأمل</MenuItem>
                        <MenuItem value="مدرسة المستقبل">
                          مدرسة المستقبل
                        </MenuItem>
                      </TextField>
                    </div>

                    <div className="col-6 mb-3 mt-4" dir="rtl">
                      <label
                        htmlFor="grade"
                        style={{
                          fontFamily: "Cairo",
                          fontSize: "14px",
                          color: "black",
                          marginBottom: "5px",
                          display: "block",
                          textAlign: "right",
                        }}
                      >
                        الفصل
                      </label>

                      <TextField
                        id="grade"
                        name="grade"
                        select
                        fullWidth
                        required
                        variant="filled"
                        value={formDatas.grade || ""}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            grade: e.target.value,
                          }))
                        }
                        InputProps={{
                          sx: {
                            backgroundColor: "#fff",
                            color: "black",
                            direction: "rtl",
                            textAlign: "right",
                            borderRadius: "8px",
                            fontFamily: "Cairo",
                            paddingRight: "16px",
                          },
                        }}
                      >
                        <MenuItem value="">اختر اسم الفصل</MenuItem>
                        <MenuItem value="الفصل الأول">الفصل الأول</MenuItem>
                        <MenuItem value="الفصل الثاني">الفصل الثاني</MenuItem>
                        <MenuItem value="الفصل الصيفي">الفصل الصيفي</MenuItem>
                      </TextField>
                    </div>

                    <div className="col-6 mb-3 mt-4" dir="rtl">
                      <label
                        htmlFor="academic_year"
                        style={{
                          fontFamily: "Cairo",
                          fontSize: "14px",
                          color: "black",
                          marginBottom: "5px",
                          display: "block",
                          textAlign: "right",
                        }}
                      >
                        السنة الدراسية
                      </label>

                      <TextField
                        id="academic_year"
                        name="academic_year"
                        select
                        fullWidth
                        required
                        variant="filled"
                        value={formDatas.academic_year || ""}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            academic_year: e.target.value,
                          }))
                        }
                        InputProps={{
                          sx: {
                            backgroundColor: "#fff",
                            color: "black",
                            direction: "rtl",
                            textAlign: "right",
                            borderRadius: "8px",
                            fontFamily: "Cairo",
                            paddingRight: "16px",
                          },
                        }}
                      >
                        <MenuItem value="">اختر السنة</MenuItem>
                        <MenuItem value="الاولى">السنة الأولى</MenuItem>
                        <MenuItem value="الثانية">السنة الثانية</MenuItem>
                        <MenuItem value="الثالثة">السنة الثالثة</MenuItem>
                        <MenuItem value="الرابعة">السنة الرابعة</MenuItem>
                      </TextField>
                    </div>

                    <div className="col-md-12 mt-4">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="termsCheck"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="termsCheck"
                        >
                          التسجيل بترحيل
                        </label>
                      </div>
                    </div>

                    <div className="col-12 mt-4">
                      <div className="d-flex justify-content-between">
                        <button
                          type="button"
                          className="btn btn-secondary px-5"
                          onClick={() => setStep(2)}
                        >
                          الرجوع
                        </button>

                        <button
                          type="submit"
                          className="btn btn px-5"
                          style={{ background: "#95c02b", color: "#fff" }}
                          disabled={isSubmitting}
                        >
                          {isSubmitting ? (
                            <>
                              <span
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              جاري الإرسال...
                            </>
                          ) : (
                            "إرسال"
                          )}
                        </button>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </form>
                  </div>
            </div>

      </div>
      <ToastContainer
        position="top-center"
        rtl
        autoClose={8000}
        toastClassName="custom-toast"
        bodyClassName="custom-toast-body"
        style={{ fontFamily: "Cairo" }}
      />
    </>
  );
};

export default RegisterPage;
